import {
  createSipClientReasonAsync,
  deleteSipClientReasonAsync,
  getAllSipClientReasonByLicenseAsync,
  getAllSipClientReasonByLicenseCountAsync,
  getSipClientReasonByIdAsync,
  updateSipClientReasonAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateSipClientReasonAsync = () =>
  useMutation(createSipClientReasonAsync);

export const useGetSipClientReasonByIdAsync = () =>
  useMutation(getSipClientReasonByIdAsync);

export const useGetAllSipClientReasonByLicenseAsync = () =>
  useMutation(getAllSipClientReasonByLicenseAsync);

export const useGetAllSipClientReasonByLicenseCountAsync = () =>
  useMutation(getAllSipClientReasonByLicenseCountAsync);

export const useUpdateSipClientReasonAsync = () =>
  useMutation(updateSipClientReasonAsync);

export const useDeleteSipClientReasonAsync = () =>
  useMutation(deleteSipClientReasonAsync);
